module.exports = __webpack_public_path__ + "static/media/pinterest.2430c144.png";